import React from 'react';
import { cls } from '../../packages/components';
import './styles/cardGrid.scss';

function CardGrid(props) {
    const imgBg = props.item && props.item.imageEpg || props.item && props.item.image || '';
    const style = {
        backgroundImage: `url('${imgBg}')`,
    };
    return (
        <div className={cls( (props.item && props.item.channel_number ? `main_cardgrid_channel_number` : `main_cardgrid`)  , (props.className ? props.className : ''))} style={style}>
            {/* {props.item.text || ''} */}
        </div>
    );
}
export default CardGrid;



// WEBPACK FOOTER //
// ./src/components/Epg/CardGrid.jsx